import { DateTimePicker } from '@mantine/dates';
import { isArray } from 'lodash';
import * as React from 'react';
import { LabelNode } from '../../../../../../react-commons/components/inputs/getLabelNode';
import { formatIdentifier } from '../../../../../../react-commons/utils/utilFunctions';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { getPropertyLabelInfo } from '../../../util/utilFunctions';
import { useSystemInformationActions } from '../../../../resource/services/systemInformationService';

export const Controlled_PropertyDateTimeInput= ({
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType },
    value,
    readOnly,
    handleChange,
    hideLabel = false,
}: {
    labelOverride?: string;
    value: Date;
    readOnly: boolean;
    propertyValidationInformation: PropertyValidationInformation;
    handleChange?: (value: Date) => void;
    hideLabel?: boolean;
}) => {
    const propertyDetails = useSystemInformationActions().useGetPropertyDetails(
        propertyIdentifier,
        resourceType
    );

    const labelInfo = hideLabel ? undefined : getPropertyLabelInfo(propertyDetails);

    const label =
        hideLabel ? undefined
        : labelOverride ? labelOverride
        : isArray(propertyDetails) ?
            propertyDetails[0]?.displayName ?
                propertyDetails[0]?.displayName
            :   formatIdentifier(propertyDetails[0]?.propertyName ?? '')
        : propertyDetails?.displayName ? propertyDetails.displayName
        : formatIdentifier(propertyDetails?.propertyName ?? '');

    return (
        <DateTimePicker
            label={label && <LabelNode label={label} labelInfo={labelInfo} />}
            value={value}
            readOnly={readOnly}
            onChange={(newDate) => {
                if (newDate && handleChange) {
                    handleChange(new Date(newDate));
                }
            }}
            clearable={false}
        />
    );
};
